import { Component, Inject, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@next/core-lib/authentication';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { MsalHelperService } from '@next/core-lib/msal';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';

import { map } from 'rxjs';

import { SiteState } from '../shared/models/siteState.model';

@Component({
  selector: 'app-developer-tools',
  templateUrl: './dev-tokens.component.html',
  standalone: false,
})
export class DevTokensComponent {
  private readonly store = inject(Store<SiteState>);
  private readonly route = inject(ActivatedRoute);
  private readonly locale = inject(LocaleService);
  private readonly authentication = inject(AuthenticationService);

  pageTitle = toSignal(this.store.select(SiteSelectors.selectPageTitle));
  user = toSignal(this.store.select(UserSelectors.selectUser));
  token$ = this.authentication.acquireTokenSilent().pipe(map((result: string) => result));
  token: string;

  constructor(
    private readonly msal: MsalHelperService,
    @Inject(EnvironmentInjector) private readonly env: AgrEnvironment,
  ) {
    effect(() => {
      const titleKey = this.route.snapshot.data['pageTitle'];
      if (titleKey) {
        this.store.dispatch(
          SiteActions.updatePageTitle({ pageTitle: this.locale.translate(titleKey) }),
        );
      }
    });
  }

  refreshJwtAuthorizations() {
    this.msal.refreshApplicationsThroughPopup([this.env.CLIENT_ID]);
    this.token$ = this.authentication.acquireTokenSilent().pipe(map((result: string) => result));
  }
}
